import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics";
import { trackRedditEvent } from "../reddit";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    trackRedditEvent("PageVisit");
  }, [location]);
};

export default usePageTracking;
